const propSetMap = {
  clients: (value) => ({ id: value.id, name: value.name }),
  users: (value) => ({ id: value.id, name: value.name, email: value.email }),
  groups: (value) => ({ id: value.id, name: value.name }),
  action: (value) => value.id,
  configurationValue: (value) => ({ id: value.id }),
}

export const getFieldValue = (value, field = "clients") => {
  if (typeof value === "string" || typeof value === "number") {
    return value;
  }
  if (!value) {
    return null;
  }
  if (Array.isArray(value)) {
    return value.map((item) => propSetMap[field](item));
  }
  if (typeof value === "object" && value !== null) {
    return propSetMap[field]?.(value) || value;
  }
}